const FourthPage = [
    {
        question: "Highest level of education?",
        type: "drop down",
        options: ["Doctorate", "Masters", "Graduate", "Undergraduate", "Not Applicable"],
        response: null
    }
];

export default FourthPage;